'use strict';

var React = require('react');
var Reflux = require('reflux');
var Router = require('react-router');

/* Actions */
var DatasourceActions = require('actions/datasource');

/* Stores */
var LanguageStore = require('stores/language');
var DatasourceStore = require('stores/datasource');

/* Components */
var Panel = require('components/ui/panel');
var Modal = require('components/ui/modal');
var ButtonGroup = require('components/ui/button-group');
var Button = require('components/ui/button');
var TextField = require('components/ui/text-field');
var ContentList = require('./content-list');
var AssignedTeamList = require('./assigned-team-list');
var AssignedUserList = require('./assigned-user-list');
var AssignedProjectList = require('./assigned-project-list');
var ContentEditor = require('./editor');

var DatasourceDetails = React.createClass({
  displayName: 'DatasourceDetails',

  mixins: [Router.Navigation],

  getInitialState: function getInitialState() {
    return {
      users: [],
      teams: [],
      projects: []
    };
  },

  componentDidMount: function componentDidMount() {
    var refs = this.refs;
    var props = this.props;
    var nameField = refs.nameField;

    if (nameField) {
      nameField.focus();
    }

    var datasource = props.datasource;
    var id = datasource.id;

    DatasourceActions.loadItems(id);
  },

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var props = this.props;
    var datasource = props.datasource;

    if (!prevProps.datasource && datasource) {
      var id = datasource.id;

      DatasourceActions.loadItems(id);
    }
  },

  render: function render() {
    var component = this;

    var _component$props = component.props;
    var create = _component$props.create;
    var datasource = _component$props.datasource;

    if (create) {
      return React.createElement(
        'form',
        { className: 'details-component datasource-create-component', onSubmit: component._onCreateSubmit },
        React.createElement(
          Panel,
          null,
          React.createElement(TextField, { ref: 'nameField', className: 'name-field', translationKey: 'datasource_details_name', value: component.state.name }),
          React.createElement(
            ButtonGroup,
            null,
            React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancel }),
            React.createElement(Button, { translationKey: 'create', type: 'submit' })
          )
        )
      );
    }

    if (!datasource) {
      return null;
    }

    var copyItemsDialog = null;
    if (this.state.shouldCopyItems) {
      var copyDestinationNodes = DatasourceStore.datasources.map(function (datasource) {
        return React.createElement(
          'option',
          { value: datasource.id },
          datasource.name
        );
      });

      copyItemsDialog = React.createElement(
        Modal,
        { className: 'copy-items', onCancel: component._onCancelCopy },
        React.createElement(
          'h2',
          null,
          'Copy to'
        ),
        React.createElement(
          'select',
          { ref: 'copyToDestinations' },
          copyDestinationNodes
        ),
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancelCopy }),
          React.createElement(Button, { translationKey: 'copy', onClick: component._onCopySubmit })
        )
      );
    }

    var createItemDialog = null;
    if (this.state.shouldCreateItem) {
      createItemDialog = React.createElement(
        Modal,
        { className: 'create-item', onCancel: component._onCancelCreateItem },
        React.createElement(
          'h2',
          null,
          'Create'
        ),
        React.createElement(
          'select',
          { ref: 'createItemSelection' },
          React.createElement(
            'optgroup',
            { label: 'Default' },
            React.createElement(
              'option',
              { value: 'empty' },
              'Empty'
            )
          ),
          React.createElement(
            'optgroup',
            { label: 'Content' },
            React.createElement(
              'option',
              { value: 'book' },
              'Book'
            ),
            React.createElement(
              'option',
              { value: 'movie' },
              'Movie'
            ),
            React.createElement(
              'option',
              { value: 'tvEpisode' },
              'TV Episode'
            ),
            React.createElement(
              'option',
              { value: 'tvSeason' },
              'TV Season'
            ),
            React.createElement(
              'option',
              { value: 'tvShow' },
              'TV Show'
            )
          ),
          React.createElement(
            'optgroup',
            { label: 'Services' },
            React.createElement(
              'option',
              { value: 'bundle' },
              'Bundle'
            ),
            React.createElement(
              'option',
              { value: 'subscription' },
              'Subscription'
            )
          ),
          React.createElement(
            'optgroup',
            { label: 'Vouchers' },
            React.createElement(
              'option',
              { value: 'discountVoucher' },
              'Discount Voucher'
            ),
            React.createElement(
              'option',
              { value: 'voucher' },
              'Voucher'
            )
          ),
          React.createElement(
            'optgroup',
            { label: 'Other' },
            React.createElement(
              'option',
              { value: 'order' },
              'Order'
            ),
            React.createElement(
              'option',
              { value: 'user' },
              'User'
            )
          )
        ),
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancelCreateItem }),
          React.createElement(Button, { translationKey: 'create', onClick: component._onCreateItemSubmit })
        )
      );
    }

    var editItemDialog = null;
    if (this.state.shouldEditItem) {
      var item = this.state.itemToEdit;

      editItemDialog = React.createElement(ContentEditor, { item: item,
        onCancel: component._onCancelEdit,
        onSave: component._onEditSubmit });
    }

    return React.createElement(
      'form',
      { className: 'details-component datasource-details-component', onSubmit: component._onSubmit },
      React.createElement(
        Panel,
        null,
        copyItemsDialog,
        createItemDialog,
        editItemDialog,
        React.createElement(TextField, { ref: 'nameField', className: 'name-field', translationKey: 'datasource_details_name', value: datasource.name }),
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancel }),
          React.createElement(Button, { translationKey: 'save', type: 'submit' }),
          React.createElement(Button, { translationKey: 'delete', className: 'delete', onClick: component._onDelete })
        ),
        React.createElement(AssignedTeamList, {
          teams: datasource.teams,
          onAssign: component._onAssignTeam,
          onUnassign: component._onUnassignTeam,
          onPermissionChange: component._onTeamPermissionChange }),
        React.createElement(AssignedUserList, {
          users: datasource.users,
          onAssign: component._onAssignUser,
          onUnassign: component._onUnassignUser,
          onPermissionChange: component._onUserPermissionChange }),
        React.createElement(AssignedProjectList, {
          projects: datasource.projects,
          onAssign: component._onAssignProject,
          onUnassign: component._onUnassignProject,
          onPermissionChange: component._onUserPermissionChange }),
        React.createElement(ContentList, { onDeleteItems: component._onDeleteItems,
          onCopyItems: component._onCopyItems,
          onCreateItem: component._onCreateItem,
          onChangeForSale: component._onChangeForSale,
          onEditItem: component._onEditItem })
      )
    );
  },

  _onCancel: function _onCancel(evt) {
    if (evt) {
      evt.preventDefault();
    }

    this.transitionTo('/');
  },

  _onCancelCopy: function _onCancelCopy() {
    this.setState({
      itemsToCopy: [],
      shouldCopyItems: false
    });
  },

  _onCancelCreateItem: function _onCancelCreateItem() {
    this.setState({
      shouldCreateItem: false
    });
  },

  _onSubmit: function _onSubmit(evt) {
    evt.preventDefault();

    var name = this.refs.nameField.value;

    DatasourceActions.submit(this.props.datasource.id, { name: name });
  },

  _onCopySubmit: function _onCopySubmit() {
    var items = this.state.itemsToCopy;
    var destinations = this.refs.copyToDestinations.getDOMNode();
    var id = destinations.options[destinations.selectedIndex].value;

    this._onCancelCopy();

    DatasourceActions.copyItemsTo(id, items);
  },

  _onCreateSubmit: function _onCreateSubmit(evt) {
    evt.preventDefault();

    var name = this.refs.nameField.value;

    DatasourceActions.create({ name: name });
  },

  _onCreateItemSubmit: function _onCreateItemSubmit() {
    var datasource = this.props.datasource;
    var id = datasource.id;

    var selections = this.refs.createItemSelection.getDOMNode();
    var selection = selections.options[selections.selectedIndex].value;

    DatasourceActions.createContent(id, selection);

    this._onCancelCreateItem();
  },

  _onCopyItems: function _onCopyItems(items) {
    this.setState({
      itemsToCopy: items,
      shouldCopyItems: true
    });
  },

  _onCreateItem: function _onCreateItem() {
    this.setState({
      shouldCreateItem: true
    });
  },

  _onEditItem: function _onEditItem(item) {
    this.setState({
      itemToEdit: item,
      shouldEditItem: true
    });
  },

  _onChangeForSale: function _onChangeForSale(item, forSale) {
    DatasourceActions.changeForSale(item, forSale);
  },

  _onCancelEdit: function _onCancelEdit() {
    this.setState({
      itemToEdit: null,
      shouldEditItem: false
    });
  },

  _onEditSubmit: function _onEditSubmit(changes, removals) {
    if (Object.keys(changes).length || Object.keys(removals).length) {
      var item = this.state.itemToEdit;

      DatasourceActions.updateContent(item.id, changes, removals);
    }

    this._onCancelEdit();
  },

  _onDelete: function _onDelete() {
    if (confirm(LanguageStore.translate('datasource_details_delete_confirmation'))) {
      DatasourceActions['delete'](this.props.datasource.id);
    }
  },

  _onDeleteItems: function _onDeleteItems(itemIds) {
    DatasourceActions.deleteItems(this.props.datasource.id, itemIds);
  },

  _onAssignTeam: function _onAssignTeam(team) {
    DatasourceActions.assignTeam(this.props.datasource.id, team.id);
  },

  _onUnassignTeam: function _onUnassignTeam(team) {
    DatasourceActions.unassignTeam(this.props.datasource.id, team.id);
  },

  _onAssignUser: function _onAssignUser(user) {
    DatasourceActions.assignUser(this.props.datasource.id, user.id);
  },

  _onUnassignUser: function _onUnassignUser(user) {
    DatasourceActions.unassignUser(this.props.datasource.id, user.id);
  },

  _onAssignProject: function _onAssignProject(project) {
    DatasourceActions.assignProject(this.props.datasource.id, project.id);
  },

  _onUnassignProject: function _onUnassignProject(project) {
    DatasourceActions.unassignProject(this.props.datasource.id, project.id);
  }
});

module.exports = DatasourceDetails;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/datasource/details.js
 **/